import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { useGetCallParticipantProperties } from "@/composables";
import { RoomParticipant } from "@/types/call";

interface Props {
  roomParticipant: RoomParticipant | null;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'MediaDisplayControl',
  props: {
    roomParticipant: {}
  },
  setup(__props: any) {

const props = __props;

const { mediaOutputRef } = useGetCallParticipantProperties(props);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    ref_key: "mediaOutputRef",
    ref: mediaOutputRef
  }, null, 512))
}
}

})